export default __webpack_public_path__ + "static/media/ayushi.794cd93e.png";